import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import CloseIcon from '../../CloseIcon/CloseIcon';

const SelectedOption = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  font-size: 10px;
  font-weight: 400;
  outline: none;
  text-transform: uppercase;

  span {
    vertical-align: text-bottom;
  }
`;

class ListItem extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  handleClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  };

  render = () => {
    const { label } = this.props;

    return (
      <li>
        <SelectedOption onClick={this.handleClick}>
          <CloseIcon size="10" /> <span>{label}</span>
        </SelectedOption>
      </li>
    );
  };
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/DesktopDropdown/SelectedOption.js